FamilycardsImageLibrary.controller('singleImageController', [ '$scope', '$http', function( $scope, $http ) {

	$scope.selectedImage = {};
	$scope.variations = {};
	$scope.isFavorite = false;
	$scope.favoriteLoading = false;
	$scope.favoriteInitiallyLoaded = false;

	$scope.getImage = function getImages()  {

		$http({
			method: 'GET',
			url: api_url_variations,
		}).
		success( function( response, status, headers, config ) {
			$scope.variations = response;
			$scope.selectedImage = response[Object.keys(response)[0]];
		}).
		error(function(data, status, headers, config) {});

	}

	$scope.selectImageFormat = function( formatId ) {

		var newVariationKey = 'format_' + formatId + '_effect_' + $scope.selectedImage.effect_id;

		$scope.selectedImage = $scope.variations[ newVariationKey ];

	}

	$scope.selectImageEffect = function( effectId ) {

		var newVariationKey = 'format_' + $scope.selectedImage.sub_format_id + '_effect_' + effectId;

		$scope.selectedImage = $scope.variations[ newVariationKey ];

	}

	$scope.switchFavorite = function( $action) {

		$scope.favoriteLoading = true;

		$http({
			method: 'GET',
			url: api_url_favorites + '/' + $action,
		}).
		success( function( response, status, headers, config ) {
			$scope.isFavorite = response.isFavorite;
			$scope.favoriteCount = response.count;
			$scope.favoriteLoading = false;
			$scope.favoriteInitiallyLoaded = true;
			jQuery('.favorite-counter').html($scope.favoriteCount);
		}).
		error(function(data, status, headers, config) {});
	}

	$scope.switchFavorite('check');
	$scope.getImage();

}]);